<template>
  <v-card round class="seat" :class="getCssClass()" v-if="player">
    <v-card-text class="no-pad">
      <div class="top-cards" >
        <poker-card class="card" v-for="k in 3" :key="k" :card="getCard(player.top, k-1)">
        </poker-card>
      </div>
      <div class="middle-cards" >
        <poker-card class="card" v-for="k in 5" :key="k" :card="getCard(player.middle, k-1)">
        </poker-card>
      </div>
      <div class="bottom-cards" >
        <poker-card class="card" v-for="k in 5" :key="k" :card="getCard(player.bottom, k-1)">
        </poker-card>
      </div>
      <div class="toplay" :class="fantasyClass()" >
        <poker-card class="card" v-for="card in player.to_play" :key="card" :card="card">
        </poker-card>
      </div>
      <div class="discard">
        <poker-card class="card" v-for="card in player.discard" :key="card" :card="card">
        </poker-card>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div dark v-bind="attrs" v-on="on">
            <div class="name" :class="player.fantasy ? 'fantasy-name' : ''">{{ player.name }}</div>
            <div class="stack">{{ getStack() }}</div>
            <div v-if="player.sitout">(sitting out)</div>
          </div>
        </template>
        <p class="mb-0">Fantasy Games: {{ fantasy_games }}</p>
        <p class="mb-0">Fantasy Error: {{ fantasy_avg_err }}</p>
        <p class="mb-0">Fantasy Error x Us: {{ fantasy_avg_err_us }}</p>
        <p class="mb-0">Games: {{ games }}</p>
        <p class="mb-0">PPG: {{ formatNumber(ppg) }}</p>
        <p class="mb-0">Games x Us: {{ games_us }}</p>
        <p class="mb-0">PPG x Us: {{ formatNumber(ppg_us) }}</p>
      </v-tooltip>
    </v-card-text>
  </v-card>
</template>

<script>

import Card from '../PokerCard.vue';
import {mapGetters} from "vuex";

export default {
  components: {
    'poker-card': Card
  },
  props: {
    player: Object,
    state: Object,
    seat: Number,
  },
  data() {
    return {
      fantasy_games: 0,
      fantasy_avg_err: 0,
      fantasy_avg_err_us: 0,
      ppg: 0,
      games: 0,
      games_us: 0,
      ppg_us: 0,
      timeout: null
    };
  },
  computed: {
    ...mapGetters([
    ])
  },
  mounted() {
    // console.log("creating interval function")
    this.timeout = setInterval(this.updateErrorRate, 60000);
    this.updateErrorRate();
  },
  unmounted() {
    clearInterval(this.timeout);
    this.timeout = null;
  },
  methods: {
    formatNumber(v, _d=2) {
      if (!v) return v;
      return (v).toFixed(_d).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    getStack() {
      let player = this.player;
      let stack = player.stack;
      let d = this.getDivider();
      return (stack / d).toFixed(2);
    },
    getChips() {
      let player = this.player;
      let d = this.getDivider();
      return (player.chips / d).toFixed(2);
    },
    getDivider() {
      if (!this.state || !this.state.settings) {
        return 1;
      }
      let s = this.state.settings;
      if (s.withDecimal) {
        return 100;
      }
      return 1;
    },
    getCssClass() {
      var css = "seat-" + this.seat;
      // console.log(this.state.active_seat);
      if (!this.state || !this.player) return css;
      if (this.state.turn === this.player.name) {
        css += " active";
      }
      return css;
    },
    getCard(cards, idx) {
      // console.log(cards, idx)
      if (idx >= cards.length) {
        return "empty";
      }
      return cards[idx];
    },
    fantasyClass() {
      if (this.player.to_play.length >= 13) {
        return 'fantasy';
      }
      return '';
    },
    updateErrorRate() {
      let self = this;
      // console.log("trying to update fantasy numbers");
      if (!this.player || !this.player.id) return;
      this.$axios.get("/api/fantasy_info/" + this.player.id)
        .then((data) => {
          let s = data.data.success;
          // console.log(data.data);
          if (!s) return;
          let opp = data.data.opponent;
          self.fantasy_avg_err = opp.error_fantasy_avg.toFixed(2);
          self.fantasy_games = opp.error_fantasy_games;
          self.fantasy_avg_err_us = opp.error_fantasy_games_us;
          self.games = opp.games;
          self.ppg = opp.games && opp.games > 0 ? opp.score / opp.games : 0
          self.games_us = opp.games_us
          self.ppg_us = opp.games_us && opp.games_us > 0 ? opp.score_us / opp.games_us : 0
        }
      );
    }
  }
}
</script>

<style scoped>
.seat {
  width: 110px;
  text-align: center;
}

.active {
  background-color: rgb(77, 77, 77) !important;
}

.fantasy-name {
  color: green !important;
}

.fantasy {
  left: -50px !important;
  top: -70px !important;
  height: 90px;
  width: 220px !important;
  flex-wrap: wrap;
}

.chips {
  color: black;
  font-weight: bold;
  background-color: cyan;
  background-blend-mode: difference;
  border: 2px solid black;
  border-radius: 20px;
  padding: 4px;
  display: flex;
  position: absolute;
}

.seat-0 {
  position: absolute;
  top: 580px;
  left: 150px;
}

.seat-1 {
  position: absolute;
  top: 240px;
  left: 20px;
}

.seat-2 {
  position: absolute;
  top: 240px;
  left: 270px;
}

.seat-0 .top-cards {
  top: -200px;
  left: -10px;
}

.seat-0 .middle-cards {
  top: -160px;
  left: -10px;
}

.seat-0 .bottom-cards {
  top: -120px;
  left: -10px;
}

.seat-0 .toplay {
  top: -50px;
  left: -10px;
  position: absolute;
  margin-bottom: -30px;
  display: flex;
  width: 160px;
}

.seat-0 .discard {
  top: -160px !important;
  left: -80px !important;
  height: 90px;
  width: 60px;
  flex-wrap: wrap;
  display: flex;
  position: absolute;
  transform: scale(0.8);
}

.seat-1 .discard {
  top: 60px !important;
  left: 0px !important;
  height: 90px;
  width: 120px;
  flex-wrap: wrap;
  display: flex;
  position: absolute;
  transform: scale(0.8);
}

.seat-2 .discard {
  top: 60px !important;
  left: 0px !important;
  height: 90px;
  width: 120px;
  flex-wrap: wrap;
  display: flex;
  position: absolute;
  transform: scale(0.8);
}


.top-cards {
  position: absolute;
  margin-bottom: -30px;
  display: flex;
  width: 160px;
  top: -130px;
  left: 0px;
}

.middle-cards {
  position: absolute;
  top: -90px;
  left: 0px;
  margin-bottom: -30px;
  display: flex;
  width: 160px;
}

.bottom-cards {
  position: absolute;
  top: -50px;
  left: 0px;
  margin-bottom: -30px;
  display: flex;
  width: 160px;
}

.card {
  margin-left: 4px;
  float: left;
}

.no-pad {
  padding: 4px;
}

.name {
  margin-top: 16px;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: lightskyblue;
  font-weight: bold;
}

.stack {
  color: lightskyblue;
  font-weight: bold;
}

</style>
